import React from "react";

// files added
import Input from "./input";
const Contactform = () => {
  return (
    <>
      <article
        aria-label="form"
        name="contact"
        className="max-w-6xl px-6 py-10 mx-auto sm:px-10 morph lg:col-span-2 xl:p-12"
      >
        <div>
          <h3 className="pb-2 text-2xl font-semibold text-gray-200 border-b-4 rounded w-36 border-cyan-600">
            Contact Me
          </h3>
        </div>

        <form
          aria-label="form"
          action="https://getform.io/f/19d0ca16-e0e0-480d-9ff6-e93a25bbecef"
          method="POST"
          className="grid grid-cols-1 mt-6 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
        >
          <div>
            <Input
              type="text"
              name="first-name"
              id="first-name"
              autoComplete="given-name"
              label="First Name"
              htmlFor="first-name"
              aria="first-name-aria"
              spID="first-name-aria"
            />
          </div>
          <div>
            <div>
              <Input
                type="text"
                name="last-name"
                id="last-name"
                label="Last Name"
                htmlFor="last-name"
                autoComplete="family-name"
                aria="last-name-aria"
                spID="last-name-aria"
              />
            </div>
          </div>
          <div>
            <div>
              <Input
                id="email"
                label="Email"
                htmlFor="email"
                name="email"
                type="email"
                autoComplete="email"
                aria="email-aria"
                spID="email-aria"
              />
            </div>
          </div>
          <div>
            <div>
              <Input
                type="text"
                name="phone"
                id="phone"
                label="Phone"
                htmlFor="phone"
                autoComplete="tel"
                support="optional"
                spID="phone-optional"
                aria="phone-optional"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div>
              <Input
                htmlFor="subject"
                label="Subject"
                type="text"
                name="subject"
                id="subject"
                aria="subject-aria"
                spID="subject-aria"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <div className="flex justify-between">
              <label
                aria-label="message"
                htmlFor="message"
                className="block text-sm font-medium text-gray-300"
              >
                {"Message"}
              </label>
              <span id="message-max" className="text-sm text-gray-500">
                {"Max. 500 characters"}
              </span>
            </div>
            <div className="mt-1">
              <textarea
                id="message"
                name="message"
                rows={4}
                className="block w-full px-4 py-3 text-gray-900 np-input border-gray-300 rounded-md  focus:border-cyan-500 focus:ring-cyan-500"
                aria-describedby="message-max"
                defaultValue=" "
              />
            </div>
          </div>
          <div className="sm:col-span-2 sm:flex sm:justify-end">
            <button
              type="submit"
              className="inline-flex items-center justify-center hover:-translate-y-2 duration-500 w-full px-6 py-3 mt-2 text-base font-normal hover:text-white  border border-transparent rounded-md shadow-sm bg-slate-200 text-slate-800 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 sm:w-auto"
            >
              Let's Work Together
            </button>
          </div>
        </form>
      </article>
    </>
  );
};

export default Contactform;
